/* eslint-disable react/destructuring-assignment */
import React, { Component } from 'react';
import { v4 as uuidv4 } from 'uuid';
import {
  Popup
} from 'semantic-ui-react';
import withScrollbar from '../Extensions/WithScrollbar';
import api from '../../api';
import RenderProjectTree from '../Extensions/RenderProjectTree';

class PolicyRow extends Component {
  constructor(props) {
    super(props);
    this.state = {
      popupStatus: {
        treePopup: false,
      },
      activeTreeIndex: '',
      securityTreeData: [],
    };
    this.handleTreeOpen = this.handleTreeOpen.bind(this);
    this.closePopup = this.closePopup.bind(this);
  }

  componentDidMount() {
  }

  componentWillUnmount() {
  }

  handleTreeOpen(ids, index) {
    //const { t } = this.props;
    const obj = JSON.parse(`[${ids}]`);
    const objData = { uploaded_file_ids: obj };
    const popupStatus = {
      treePopup: true,
    };

    api
      .getProjectTree(objData)
      .then((response) => {
        const data = response.response;
        this.setState({
          securityTreeData: data,
          popupStatus,
          activeTreeIndex: index,
        });
      })
      .catch((err) => {
        console.log(err);
        /*
        this.setState({
          error: t('modal.error.error_load'),
        });
      */
      });
  }

  closePopup() {
    const popupStatus = {
      treePopup: false,
    };

    this.setState({
      popupStatus,
      activeTreeIndex: '',
    });
  }

  render() {
    const {
      rowData,
      t,
      state,
      policyId,
      location,
      params,
    } = this.props;

    const {
      popupStatus,
      activeTreeIndex,
      securityTreeData,
    } = this.state;

    const pathname = location.pathname ? location.pathname : location;

    if (pathname.indexOf(params.idReport) > -1) {
      return rowData.detected.map((list, i) => {
        return (
          <table
            className="wide_card_table wide_card_item"
            key={uuidv4()}
          >
            <colgroup>
              <col style={{ width: '27.2%' }} />
              <col style={{ width: '45.54%' }} />
              <col style={{ width: '27.2%' }} />
            </colgroup>
            <tbody>
              {
                rowData.category === 'component'
                && (
                  <tr>
                    <td
                      className="tal border-bottom"
                      style={{
                        paddingLeft: '7px',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap',
                      }}
                    >
                      {list.name}
                    </td>
                    <td
                      className="sum_td tac border-bottom"
                      style={{ outline: 'none' }}
                    >
                      <Popup
                        trigger={(
                          <div
                            className="hover_area"
                            style={{ outline: 'none' }}
                          >
                            <table className="sub_table">
                              <colgroup>
                                <col style={{ width: '33%' }} />
                                <col style={{ width: '33%' }} />
                                <col style={{ width: '33%' }} />
                              </colgroup>
                              <tbody>
                                <tr>
                                  <td className="tac">{list.project_count}</td>
                                  <td className="tac">{list.project_version_count}</td>
                                  <td className="tac">{list.uploaded_file_count}</td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        )}
                        on="click"
                        position="bottom left"
                        open={
                          popupStatus.treePopup && activeTreeIndex === `${policyId}_${i}`
                        }
                        onOpen={() => {
                          return this.handleTreeOpen(list.uploaded_file_ids, `${policyId}_${i}`);
                        }}
                        onClose={this.closePopup}
                        wide="very"
                      >

                        <RenderProjectTree
                          treeData={securityTreeData}
                          translate={t}
                          tableType
                          state={state}
                        />
                      </Popup>
                    </td>
                    <td
                      className="tac border-bottom"
                      style={{
                        paddingLeft: '7px',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap',
                      }}
                    >
                      {list.last_detected}
                    </td>
                  </tr>
                )
              }
              {
                rowData.category === 'security'
                && (
                  <tr>
                    <td
                      className="tal border-bottom"
                      style={{
                        paddingLeft: '7px',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap',
                      }}
                    >
                      <div className="value_wrap">
                        {
                          list.more === 'critical'
                      && <div className="bullet red">{list.name}</div>
                        }
                        {
                          list.more === 'high'
                      && <div className="bullet orange">{list.name}</div>
                        }
                        {
                          list.more === 'medium'
                      && <div className="bullet cheese">{list.name}</div>
                        }
                        {
                          list.more === 'low'
                      && <div className="bullet yellow">{list.name}</div>
                        }
                      </div>
                    </td>
                    <td
                      className="sum_td tac border-bottom"
                      style={{ outline: 'none' }}
                    >
                      <Popup
                        trigger={(
                          <div
                            className="hover_area"
                            style={{ outline: 'none' }}
                          >
                            <table className="sub_table">
                              <colgroup>
                                <col style={{ width: '33%' }} />
                                <col style={{ width: '33%' }} />
                                <col style={{ width: '33%' }} />
                              </colgroup>
                              <tbody>
                                <tr>
                                  <td className="tac">{list.project_count}</td>
                                  <td className="tac">{list.project_version_count}</td>
                                  <td className="tac">{list.uploaded_file_count}</td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        )}
                        on="click"
                        position="bottom left"
                        open={
                          popupStatus.treePopup && activeTreeIndex === `${policyId}_${i}`
                        }
                        onOpen={() => {
                          return this.handleTreeOpen(list.uploaded_file_ids, `${policyId}_${i}`);
                        }}
                        onClose={this.closePopup}
                        wide="very"
                      >
                        <RenderProjectTree
                          treeData={securityTreeData}
                          translate={t}
                          tableType
                          state={state}
                        />
                      </Popup>
                    </td>
                    <td
                      className="tac border-bottom"
                      style={{
                        paddingLeft: '7px',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap',
                      }}
                    >
                      {list.last_detected}
                    </td>
                  </tr>
                )
              }
              {
                rowData.category === 'license'
                && (
                  <tr>
                    <td
                      className="tal border-bottom"
                      style={{
                        paddingLeft: '7px',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap',
                      }}
                    >
                      <div className="value_wrap">
                        {
                          list.more === 'protective'
                      && <div className="bullet bullet_disk red">{list.name}</div>
                        }
                        {
                          list.more === 'permissive'
                      && <div className="bullet bullet_disk orange">{list.name}</div>
                        }
                        {
                          list.more === 'others'
                      && <div className="bullet bullet_disk yellow">{list.name}</div>
                        }
                      </div>
                    </td>
                    <td
                      className="sum_td tac border-bottom"
                      style={{ outline: 'none' }}
                    >
                      <Popup
                        trigger={(
                          <div
                            className="hover_area"
                            style={{ outline: 'none' }}
                          >
                            <table className="sub_table">
                              <colgroup>
                                <col style={{ width: '33%' }} />
                                <col style={{ width: '33%' }} />
                                <col style={{ width: '33%' }} />
                              </colgroup>
                              <tbody>
                                <tr>
                                  <td className="tac">{list.project_count}</td>
                                  <td className="tac">{list.project_version_count}</td>
                                  <td className="tac">{list.uploaded_file_count}</td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        )}
                        on="click"
                        position="bottom left"
                        open={
                          popupStatus.treePopup && activeTreeIndex === `${policyId}_${i}`
                        }
                        onOpen={() => {
                          return this.handleTreeOpen(list.uploaded_file_ids, `${policyId}_${i}`);
                        }}
                        onClose={this.closePopup}
                        wide="very"
                      >
                        <RenderProjectTree
                          treeData={securityTreeData}
                          translate={t}
                          tableType
                          state={state}
                        />
                      </Popup>
                    </td>
                    <td
                      className="tac border-bottom"
                      style={{
                        paddingLeft: '7px',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap',
                      }}
                    >
                      {list.last_detected}
                    </td>
                  </tr>
                )
              }
              {
                rowData.category === 'litigator'
                && (
                  <tr>
                    <td
                      className="tal border-bottom"
                      style={{
                        paddingLeft: '7px',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap',
                      }}
                    >
                      {list.name}
                    </td>
                    <td
                      className="sum_td tac border-bottom"
                      style={{ outline: 'none' }}
                    >
                      <Popup
                        trigger={(
                          <div
                            className="hover_area"
                            style={{ outline: 'none' }}
                          >
                            <table className="sub_table">
                              <colgroup>
                                <col style={{ width: '33%' }} />
                                <col style={{ width: '33%' }} />
                                <col style={{ width: '33%' }} />
                              </colgroup>
                              <tbody>
                                <tr>
                                  <td className="tac">{list.project_count}</td>
                                  <td className="tac">{list.project_version_count}</td>
                                  <td className="tac">{list.uploaded_file_count}</td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        )}
                        on="click"
                        position="bottom left"
                        open={
                          popupStatus.treePopup && activeTreeIndex === `${policyId}_${i}`
                        }
                        onOpen={() => {
                          return this.handleTreeOpen(list.uploaded_file_ids, `${policyId}_${i}`);
                        }}
                        onClose={this.closePopup}
                        wide="very"
                      >
                        <RenderProjectTree
                          treeData={securityTreeData}
                          translate={t}
                          tableType
                          state={state}
                        />
                      </Popup>
                    </td>
                    <td
                      className="tac border-bottom"
                      style={{
                        paddingLeft: '7px',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap',
                      }}
                    >
                      {list.last_detected}
                    </td>
                  </tr>
                )
              }
            </tbody>
          </table>
        );
      });
    }
    return rowData.detected.map((list, i) => {
      return (
        <table
          className="wide_card_table wide_card_item"
          key={uuidv4()}
        >
          <colgroup>
            <col style={{ width: '27.2%' }} />
            <col style={{ width: '45.54%' }} />
            <col style={{ width: '27.2%' }} />
          </colgroup>
          <tbody>
            {
              rowData.category === 'component'
              && (
                <tr>
                  <td
                    className="tal border-bottom"
                    style={{
                      paddingLeft: '7px',
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                      whiteSpace: 'nowrap',
                    }}
                  >
                    {list.name}
                  </td>
                  <td
                    className="sum_td tac border-bottom"
                    style={{ outline: 'none' }}
                  >
                    <Popup
                      trigger={(
                        <div
                          className="hover_area"
                          style={{ outline: 'none' }}
                        >
                          <table className="sub_table">
                            <colgroup>
                              <col style={{ width: '33%' }} />
                              <col style={{ width: '33%' }} />
                              <col style={{ width: '33%' }} />
                            </colgroup>
                            <tbody>
                              <tr>
                                <td className="tac">{list.project_count}</td>
                                <td className="tac">{list.project_version_count}</td>
                                <td className="tac">{list.uploaded_file_count}</td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      )}
                      on="click"
                      position="bottom left"
                      open={
                        popupStatus.treePopup && activeTreeIndex === `${policyId}_${i}`
                      }
                      onOpen={() => {
                        return this.handleTreeOpen(list.uploaded_file_ids, `${policyId}_${i}`);
                      }}
                      onClose={this.closePopup}
                      wide="very"
                    >

                      <RenderProjectTree
                        treeData={securityTreeData}
                        translate={t}
                        tableType
                        state={state}
                      />
                    </Popup>
                  </td>
                  <td
                    className="tac border-bottom"
                    style={{
                      paddingLeft: '7px',
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                      whiteSpace: 'nowrap',
                    }}
                  >
                    {list.last_detected}
                  </td>
                </tr>
              )
            }
            {
              rowData.category === 'security'
              && (
                <tr>
                  <td
                    className="tal border-bottom"
                    style={{
                      paddingLeft: '7px',
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                      whiteSpace: 'nowrap',
                    }}
                  >
                    <div className="value_wrap">
                      {
                        list.more === 'critical'
                    && <div className="bullet red">{list.name}</div>
                      }
                      {
                        list.more === 'high'
                    && <div className="bullet orange">{list.name}</div>
                      }
                      {
                        list.more === 'medium'
                    && <div className="bullet cheese">{list.name}</div>
                      }
                      {
                        list.more === 'low'
                    && <div className="bullet yellow">{list.name}</div>
                      }
                    </div>
                  </td>
                  <td
                    className="sum_td tac border-bottom"
                    style={{ outline: 'none' }}
                  >
                    <Popup
                      trigger={(
                        <div
                          className="hover_area"
                          style={{ outline: 'none' }}
                        >
                          <table className="sub_table">
                            <colgroup>
                              <col style={{ width: '33%' }} />
                              <col style={{ width: '33%' }} />
                              <col style={{ width: '33%' }} />
                            </colgroup>
                            <tbody>
                              <tr>
                                <td className="tac">{list.project_count}</td>
                                <td className="tac">{list.project_version_count}</td>
                                <td className="tac">{list.uploaded_file_count}</td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      )}
                      on="click"
                      position="bottom left"
                      open={
                        popupStatus.treePopup && activeTreeIndex === `${policyId}_${i}`
                      }
                      onOpen={() => {
                        return this.handleTreeOpen(list.uploaded_file_ids, `${policyId}_${i}`);
                      }}
                      onClose={this.closePopup}
                      wide="very"
                    >
                      <RenderProjectTree
                        treeData={securityTreeData}
                        translate={t}
                        tableType
                        state={state}
                      />
                    </Popup>
                  </td>
                  <td
                    className="tac border-bottom"
                    style={{
                      paddingLeft: '7px',
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                      whiteSpace: 'nowrap',
                    }}
                  >
                    {list.last_detected}
                  </td>
                </tr>
              )
            }
            {
              rowData.category === 'license'
              && (
                <tr>
                  <td
                    className="tal border-bottom"
                    style={{
                      paddingLeft: '7px',
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                      whiteSpace: 'nowrap',
                    }}
                  >
                    <div className="value_wrap">
                      {
                        list.more === 'protective'
                    && <div className="bullet bullet_disk red">{list.name}</div>
                      }
                      {
                        list.more === 'permissive'
                    && <div className="bullet bullet_disk orange">{list.name}</div>
                      }
                      {
                        list.more === 'others'
                    && <div className="bullet bullet_disk yellow">{list.name}</div>
                      }
                    </div>
                  </td>
                  <td
                    className="sum_td tac border-bottom"
                    style={{ outline: 'none' }}
                  >
                    <Popup
                      trigger={(
                        <div
                          className="hover_area"
                          style={{ outline: 'none' }}
                        >
                          <table className="sub_table">
                            <colgroup>
                              <col style={{ width: '33%' }} />
                              <col style={{ width: '33%' }} />
                              <col style={{ width: '33%' }} />
                            </colgroup>
                            <tbody>
                              <tr>
                                <td className="tac">{list.project_count}</td>
                                <td className="tac">{list.project_version_count}</td>
                                <td className="tac">{list.uploaded_file_count}</td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      )}
                      on="click"
                      position="bottom left"
                      open={
                        popupStatus.treePopup && activeTreeIndex === `${policyId}_${i}`
                      }
                      onOpen={() => {
                        return this.handleTreeOpen(list.uploaded_file_ids, `${policyId}_${i}`);
                      }}
                      onClose={this.closePopup}
                      wide="very"
                    >
                      <RenderProjectTree
                        treeData={securityTreeData}
                        translate={t}
                        tableType
                        state={state}
                      />
                    </Popup>
                  </td>
                  <td
                    className="tac border-bottom"
                    style={{
                      paddingLeft: '7px',
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                      whiteSpace: 'nowrap',
                    }}
                  >
                    {list.last_detected}
                  </td>
                </tr>
              )
            }
            {
              rowData.category === 'litigator'
              && (
                <tr>
                  <td
                    className="tal border-bottom"
                    style={{
                      paddingLeft: '7px',
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                      whiteSpace: 'nowrap',
                    }}
                  >
                    {list.name}
                  </td>
                  <td
                    className="sum_td tac border-bottom"
                    style={{ outline: 'none' }}
                  >
                    <Popup
                      trigger={(
                        <div
                          className="hover_area"
                          style={{ outline: 'none' }}
                        >
                          <table className="sub_table">
                            <colgroup>
                              <col style={{ width: '33%' }} />
                              <col style={{ width: '33%' }} />
                              <col style={{ width: '33%' }} />
                            </colgroup>
                            <tbody>
                              <tr>
                                <td className="tac">{list.project_count}</td>
                                <td className="tac">{list.project_version_count}</td>
                                <td className="tac">{list.uploaded_file_count}</td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      )}
                      on="click"
                      position="bottom left"
                      open={
                        popupStatus.treePopup && activeTreeIndex === `${policyId}_${i}`
                      }
                      onOpen={() => {
                        return this.handleTreeOpen(list.uploaded_file_ids, `${policyId}_${i}`);
                      }}
                      onClose={this.closePopup}
                      wide="very"
                    >
                      <RenderProjectTree
                        treeData={securityTreeData}
                        translate={t}
                        tableType
                        state={state}
                      />
                    </Popup>
                  </td>
                  <td
                    className="tac border-bottom"
                    style={{
                      paddingLeft: '7px',
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                      whiteSpace: 'nowrap',
                    }}
                  >
                    {list.last_detected}
                  </td>
                </tr>
              )
            }
          </tbody>
        </table>
      );
    });
  }
}

export default withScrollbar(PolicyRow);
